module.exports = __webpack_public_path__ + "static/media/fachadArena.20cd32b6.jpg";